import React, {useMemo} from 'react';
import UpcomingGames from '../../components/game/UpcomingGames';
import NewsHoverContainer from '../../components/news_hover/NewsHoverContainer';
import SectionHeader from '../../components/SectionHeader';
import Sponsors from '../../components/sponsors/Sponsors';
import LeagueTable from '../../components/table/LeagueTable';
import {CATEGORY} from '../../config';
import pages from '../../content/pages.json';
import site from '../../content/site.json';
import {useSiteConfig} from '../../data/ConfigContext';
import {useArticles} from '../../data/resources';
import {usePageMeta} from '../../seo/usePageMeta';

const Home = () => {
    usePageMeta({});
    const config = useSiteConfig();
    const {data: articles} = useArticles();

    const importantArticles = useMemo(
        () => (articles ?? []).filter(article => article.categories.includes(CATEGORY.important)),
        [articles]);

    return (
        <div className="page">
            {/* the page's main heading for search engines and screen readers; the design starts with the news */}
            <h1 className="visually-hidden">{site.legalName}</h1>

            <NewsHoverContainer articles={importantArticles} loading={!articles}/>

            <SectionHeader title="Nächste Spiele" link={{to: pages.schedule.path, label: 'Alle Termine'}}/>
            <UpcomingGames/>

            {config?.tables.length ? (
                <>
                    <SectionHeader title="Tabellen"/>
                    <div className="tables-grid">
                        {config.tables.map(league => <LeagueTable key={league.bew_id} league={league}/>)}
                    </div>
                </>
            ) : null}

            <Sponsors/>
        </div>
    );
};

export default Home;
